import React from 'react';
import PropTypes from 'prop-types';
import BulkPrintingListItem from './BulkPrintingListItem';
import { Checkbox, Table, TableBody, TableCell, TableRow, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BoldTableHead } from 'components/common/CommonStyles';

const BulkPrintingList = ({ bulkPrintingOffers, onSelectOffer, selectedOfferList, checkAllOffers, handleCheckAll }) => {
  const [t] = useTranslation();

  return (
    <Table>
      <BoldTableHead>
        <TableRow>
          <TableCell>
            <Tooltip title={t('SelectAll')}>
              <Checkbox checked={checkAllOffers} onChange={handleCheckAll} />
            </Tooltip>
          </TableCell>
          <TableCell>{t('BulkPrinting.OfferNumber')}</TableCell>
          <TableCell>{t('BulkPrinting.OfferClient')}</TableCell>
          <TableCell>{t('BulkPrinting.ContractNumbers')}</TableCell>
          <TableCell>{t('BulkPrinting.OfferDate')}</TableCell>
          <TableCell>{t('BulkPrinting.OfferState')}</TableCell>
        </TableRow>
      </BoldTableHead>
      <TableBody>
        {bulkPrintingOffers.map((item, idx) => {
          return (
            <BulkPrintingListItem key={idx} item={item} index={idx} onSelectOffer={onSelectOffer} selectedOfferList={selectedOfferList} />
          );
        })}
      </TableBody>
    </Table>
  );
};

BulkPrintingList.propTypes = {
  bulkPrintingOffers: PropTypes.array.isRequired,
  onSelectOffer: PropTypes.func.isRequired,
  selectedOfferList: PropTypes.array,
  handleCheckAll: PropTypes.func,
  checkAllOffers: PropTypes.bool
};

export default BulkPrintingList;
